<div class="dashboard__content-col">
<app-partners-list></app-partners-list>
</div>